import React from "react";
import ReactPlayer from "react-player";

const VideoPlayer = ({ videoPath }) => {
  return (
    <div style={{ marginTop: "20px" }}>
      <ReactPlayer
        url={videoPath}
        playing
        controls
        width="80%"
        height="80%"
        style={{ maxWidth: "20rem", margin: "auto" }}
      />
    </div>
  );
};

export default VideoPlayer;
